module.exports = __webpack_public_path__ + "img/full_service.8aeb3aaa.svg";